import { render, staticRenderFns } from "./common-rich-text-box.vue?vue&type=template&id=a84a8cc8"
import script from "./common-rich-text-box.vue?vue&type=script&lang=js"
export * from "./common-rich-text-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports